import type { CloudGraphMessageEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI: CloudGraphMessageEntityAti[] = [
	'ati:cloud:graph:message',
];
